export enum TRAFFIC_LIGHT_STATUS {
  FAILURE = 'FAILURE',
  WARNING = 'WARNING',
  RUNNING = 'RUNNING',
  OFFLINE = 'OFFLINE',
  INFO = 'INFO',
  CANNOT_EVALUATE = 'CANNOT_EVALUATE'
}

export enum TRAFFIC_LIGHT_STATUS_CLASS {
  FAILURE = 'failure',
  WARNING = 'warning',
  RUNNING = 'running',
  OFFLINE = 'offline',
  CANNOT_EVALUATE = 'cannot_evaluate',
  INFO = 'info',
  BUTTON = 'btn'
}


